import { createAsyncThunk } from "@reduxjs/toolkit";
import { IBranchDetails } from "../branchModal";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllBranches = createAsyncThunk(
  "branch/FindAllBranch",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/FindAllBranch`,
        {
          BranchName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Create Branch
export const createBranch = createAsyncThunk(
  "branch/InsertBranch",
  async (branchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/InsertBranch`,
        branchData,
      );
      SuccessToast(response.data?.Details || "Branch created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Update Branch
export const updateBranch = createAsyncThunk(
  "branch/UpdateBranch",
  async (branchData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/UpdateBranch`,
        branchData,
      );
      SuccessToast(response.data?.Details || "Branch updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Delete Branch
export const deleteBranch = createAsyncThunk(
  "branch/DeleteBranch",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/DeleteBranch`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Branch deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Get Branch By ID
export const getBranchByID = createAsyncThunk(
  "branch/FindByIDBranch",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/FindByIDBranch`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result.ID,
        BranchName: result.BranchName,
        BranchAddress: result.BranchAddress,
        CityID: result.CityID,
        StateID: result.StateID,
        Pincode: result.Pincode,
        MobileNumber: result.MobileNumber,
        Email: result.Email,
        IsActive: result.IsActive === true ? 1 : 2,
      } as IBranchDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching branch:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Get All Active Branches
export const getAllActiveBranches = createAsyncThunk(
  "branch/FindAllActiveBranch",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Branch/FindAllActiveBranch`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Branches:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Active/Inactive Branch
export const activeInActiveBranch = createAsyncThunk(
  "branch/ActiveInActiveBranch",
  async (data: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Branch/ActiveInActiveBranch`,
        data,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating branch status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
